import scheduleChangeRefetch from '../../RotationSchedulePanel/scheduleChangeRefetch';

export default function buildRefetchQueries({ weekStart, dealerId }) {
  return () => scheduleChangeRefetch(weekStart, dealerId);
}



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/DeleteContactModal/buildRefetchQueries.js